import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Legacy PrimaryButton wrapper — delegates to shadcn Button with the brand
 * primary variant. Existing call sites continue to work unchanged.
 *
 * Migration target: callers should import { Button } from '@/components/ui/button'
 * directly. This file exists only to keep legacy imports working during the
 * rollout and will be removed once all callers are migrated.
 */
const sizeMap = { small: "sm", medium: "default", large: "lg" };

const PrimaryButton = React.forwardRef(
  ({ size = "medium", fullWidth = false, className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="gold"
      size={sizeMap[size] || "default"}
      className={cn(fullWidth && "w-full", className)}
      {...props}
    />
  ),
);
PrimaryButton.displayName = "PrimaryButton";

export default PrimaryButton;
